export enum DocumentType {
    Summary = 'summary',
    Lecture = 'lecture',
    Exam = 'exam',
    Assignment = 'assignment',
    Other = 'other',
}
